import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Catalog } from './catalog';

import { Configuration } from '../../../app.constants';
import { AuthenticationService } from '../../../shared/services/authentication.service';


@Injectable()
export class CatalogService {

    private _apiCatalogUrl = this._configuration.apiUrl + "/v2/catalog";
    private _apiCatalogItemsUrl = this._configuration.apiUrl + "/v2/catalogItems";

    private headers: Headers;

    constructor(
        private _http: Http,
        private _configuration: Configuration,
        public _authService: AuthenticationService)
        { }

    getCatalogs(): Observable<Catalog[]> {

        let h = this._authService.getHeaders();

        return this._http.get(this._apiCatalogUrl, { headers: h, search: null }).map(
            response => {
                let body = response.json();
                if (body['catalogs'] == null || !Array.isArray(body['catalogs']))
                    return [];
                return body['catalogs'];
            }
        );
    }
  

    deleteCatalog(id: string) {
        let h = this._authService.getHeaders();
        let s = new URLSearchParams();
    
        s.append('id', id);
        return this._http.delete(this._apiCatalogUrl, { headers: h, search: s }).map(response => response.json());
    }

    getOneCatalog(id: string) : Observable<Catalog>  {
    
        let cat:Catalog = new Catalog();    
        return Observable.of(cat);
    }

}

/*
import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { Configuration } from '../../../app.constants';
import { Product } from './product';
import { FabricType } from './fabrictype';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Injectable()
export class ProductService {
    private _apiProductUrl = this._configuration.apiUrl + "/v2/product";
    private _fabricTypeUrl = this._configuration.apiUrl + "/v2/fabric";
    private _designUrl = this._configuration.apiUrl + "/v2/design";

    private _collDesignUrl = this._configuration.apiUrl + "/v2/collection/design";
    private _desColorUrl = this._configuration.apiUrl + "/v2/design/color";

    private headers: Headers;

    constructor(private _http: Http,
        private _configuration: Configuration,
        public _authService: AuthenticationService) { }


    getFabricTypes(): Observable<FabricType[]> {
        let h = this._authService.getHeaders();

        return this._http.get(this._fabricTypeUrl, { headers: h, search: null }).map(
            response => {
                let body = response.json();
                if (body['fabrictypes'] == null || !Array.isArray(body['fabrictypes']))
                    return [];
                return body['fabrictypes'];
            }
        );
    }

    getProducts(): Observable<Product[]> {
        let h = this._authService.getHeaders();

        return this._http.get(this._apiProductUrl + "?min=1", { headers: h, search: null }).map(
            response => {
                let body = response.json();
                let p: Product[];

                if (body['products'] == null || !Array.isArray(body['products'])) {
                    p = [];
                } else {
                    p = body['products'];
                }

                p.forEach(
                    function (p) {
                        if (!Array.isArray(p.attachments))
                            p.attachments = [];
                    }
                );
                return p;
            }
        );
    }

    getOneProduct(id: string): Observable<Product> {
        let h = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.get(this._apiProductUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();

                let p: Product;

                if (body['products'] == null || !Array.isArray(body['products'])) {
                    p = new Product();
                } else {
                    p = body['products'][0];
                }
                if (!Array.isArray(p.attachments))
                    p.attachments = [];

                return p;
            }
        );
    }

    getOneProductFromExternalName(collection: string, design: string, color: string): Observable<Product> {
        let h = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('external', 'true');
        s.append('collection', collection);
        s.append('design', design);
        s.append('color', color);

        return this._http.get(this._apiProductUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();

                let p: Product;

                if (body['products'] == null || !Array.isArray(body['products'])) {
                    p = new Product();
                } else {
                    p = body['products'][0];
                }
                if (!Array.isArray(p.attachments))
                    p.attachments = [];

                return p;
            }
        );
    }

    getProductTypes(): Observable<string[]> {
        let h = this._authService.getHeaders();

        return this._http.get(this._fabricTypeUrl, { headers: h, search: null }).map(
            response => {
                let body = response.json();
                if (body['fabrictypes'] == null || !Array.isArray(body['fabrictypes']))
                    return [];
                return body['fabrictypes'];
            }
        );
    }

    createProduct(product: Product) {
        let h = this._authService.getHeaders();

        return this._http.post(this._apiProductUrl, product, { headers: h, search: null }).map(response => response.json());
    }

    updateProduct(id: string, product: Product) {
        let h = this._authService.getHeaders();
        let s = new URLSearchParams();

        s.append('id', id);

        return this._http.put(this._apiProductUrl, product, { headers: h, search: s }).map(response => response.json());
    }

    deleteProduct(id: string) {
        let h = this._authService.getHeaders();
        let s = new URLSearchParams();

        s.append('id', id);

        return this._http.delete(this._apiProductUrl, { headers: h, search: s }).map(response => Object.assign(response.json(), { id: id }));
    }

    getDesignPrices(): Observable<any[]> {
        let h = this._authService.getHeaders();

        return this._http.get(this._designUrl, { headers: h, search: null }).map(
            response => {
                let body = response.json();
                if (body['designs'] == null || !Array.isArray(body['designs']))
                    return [];
                return body['designs'];
            }
        );
    }

    updateDesignPrice(id: string, price: number) {
        let h = this._authService.getHeaders();
        let s = new URLSearchParams();

        s.append('id', id);

        return this._http.put(this._designUrl, { unit_price_eur: price }, { headers: h, search: s }).map(response => response.json());
    }

    getDesignsPerCollection(collection_id): Observable<{ id: number, name: string }[]> {
        let h = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('collection_id', collection_id);

        console.log(collection_id);

        return this._http.get(this._collDesignUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['designs'] == null || !Array.isArray(body['designs']))
                    return [];
                return body['designs'];
            }
        );
    }

    getColorsPerDesign(design_id): Observable<{ id: number, name: string }[]> {
        let h = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('design_id', design_id);

        return this._http.get(this._desColorUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['colors'] == null || !Array.isArray(body['colors']))
                    return [];
                return body['colors'];
            }
        );
    }

}
*/


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/catalogs/catalog.service.ts